var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShieldFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M1.005 4.525c.209 3.28.985 4.507 1.742 5.933C3.952 12.577 5.172 13.732 7 14.883c.886.45 1.161.45 2.051 0 1.84-1.153 3.026-2.305 4.23-4.425.761-1.433 1.534-2.645 1.716-5.933.038-.69-.185-1.027-.529-1.027-2.739 0-4.989-1.57-6.113-2.49a.47.47 0 00-.64 0c-1.149.921-3.401 2.454-6.12 2.49-.345.004-.634.33-.589 1.027z"
  })));
}

export default SvgShieldFooter;